export default __webpack_public_path__ + "static/helveticaNeue-de0dc79893d5e398ae047b9924f9d4f2.woff2";